import React, { useEffect } from 'react';

import { EmblaOptionsType } from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import Fade from 'embla-carousel-fade';
import useEmblaCarousel from 'embla-carousel-react';

import { NextButton, PrevButton, usePrevNextButtons } from './embla-carousel-arrow-button';
import { DotButton, useDotButton } from './embla-carousel-dot-button';

import './embla.css';

import { cn } from '~/lib/utils';
import { getBannerList } from '~/services/api/homepage-banner';

type PropType = {
  banners: Awaited<ReturnType<typeof getBannerList>>['list'];
  options?: EmblaOptionsType;
};

const EmblaCarousel: React.FC<PropType> = (props) => {
  const { banners, options } = props;
  const autoplayOptions = { delay: 8000 }; // Carousel speed
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [Fade(), Autoplay(autoplayOptions)]);

  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi);

  const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi);

  useEffect(() => {
    if (emblaApi) {
      emblaApi.on('select', () => {
        emblaApi.plugins().autoplay.play();
      });
    }
  }, [emblaApi]);

  return (
    <div className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {banners.map((b, index) => (
            <div className="embla__slide" key={index}>
              <div className="embla__slide__wrapper">
                {b.link ? (
                  <a href={b.link} target="_blank" rel="noopener noreferrer">
                    <img className="embla__slide__img" src={b.image} alt={`banner-image-${index + 1}`} />
                  </a>
                ) : (
                  <img className="embla__slide__img" src={b.image} alt={`banner-image-${index + 1}`} />
                )}
                <div className="embla__controls">
                  <div className="embla__buttons">
                    <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
                    <div className="embla__dots">
                      {scrollSnaps.map((_, index) => (
                        <DotButton
                          key={index}
                          onClick={() => onDotButtonClick(index)}
                          className={cn('embla__dot', index === selectedIndex && 'embla__dot--selected')}
                        />
                      ))}
                    </div>
                    <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmblaCarousel;
